import { render, staticRenderFns } from "./qTextArea.vue?vue&type=template&id=5cb03528&scoped=true&"
import script from "./qTextArea.vue?vue&type=script&lang=ts&"
export * from "./qTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./qTextArea.vue?vue&type=style&index=0&id=5cb03528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb03528",
  null
  
)

export default component.exports